module.exports = __webpack_public_path__ + "static/media/git.5ab5d9a3.svg";